import { render, staticRenderFns } from "./Mobiedu.vue?vue&type=template&id=549ab400"
import script from "./Mobiedu.vue?vue&type=script&lang=js"
export * from "./Mobiedu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports